import React, { useEffect, useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import Image from "react-bootstrap/Image";
import { Link, useNavigate } from "react-router-dom";
import blankProfileImage from "assets/images/blank-profile-picture1280.png";
import { user } from "redux-store/user/user.selectors";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "redux-store/store";
import { getLoggedInUser, userClean } from "redux-store/user/user.slice";
import { OC_TOKEN } from "utils/constants";
import { messageCleanUp } from "redux-store/auth/auth.slice";

import "./ProfileDropdown.css";
import { petsClean } from "redux-store/pets/pet.slice";

const ProfileDropdown = () => {
  const loggedInUser = useSelector(user);
  const dispatch = useDispatch<AppDispatch>();

  const navigate = useNavigate();
  const [userData, setUserData] = useState({
    _id: loggedInUser?._id,
    fullName: loggedInUser?.fullName,
    profile: loggedInUser?.profile,
  });

  useEffect(() => {
    try {
      dispatch(getLoggedInUser());
    } catch (error) {
      console.log(error);
    }
  }, []);

  useEffect(() => {
    loggedInUser &&
      setUserData({
        _id: loggedInUser?._id,
        fullName: loggedInUser?.fullName,
        profile: loggedInUser?.profile,
      });
  }, [loggedInUser]);

  return (
    <Dropdown
      align="end"
      className="oc-profile-dropdown tw-hidden min-[990px]:tw-block"
    >
      <Dropdown.Toggle id="oc-profile-dropdown" as="div">
        <Image
          src={userData?.profile || blankProfileImage}
          roundedCircle
          className="tw-h-[60px] tw-w-[60px] tw-object-cover"
        />
      </Dropdown.Toggle>

      <Dropdown.Menu flip>
        <Dropdown.Header>{userData?.fullName}</Dropdown.Header>
        {!loggedInUser?.isAdmin && (
          <Dropdown.Item
            className="hover:tw-bg-reddishOrange hover:tw-text-white"
            eventKey="myAccount"
          >
            <Link
              to={`/${loggedInUser?.isAdmin ? "admin" : "user"}/my-profile/${
                userData?._id
              }`}
              className={`${
                loggedInUser?.isHospital ? "tw-hidden" : "hover:tw-text-white"
              }`}
            >
              My Account
            </Link>
          </Dropdown.Item>
        )}
        <Dropdown.Item
          className="hover:tw-bg-reddishOrange hover:tw-text-white"
          eventKey="logout"
          onClick={() => {
            localStorage.removeItem(OC_TOKEN);
            dispatch(messageCleanUp());
            dispatch(userClean());
            dispatch(petsClean());
            navigate("/");
          }}
        >
          Logout
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default ProfileDropdown;
